import { render, staticRenderFns } from "./DraggableTree.vue?vue&type=template&id=5de9c53e&scoped=true"
import script from "./DraggableTree.vue?vue&type=script&lang=ts"
export * from "./DraggableTree.vue?vue&type=script&lang=ts"
import style0 from "./DraggableTree.vue?vue&type=style&index=0&id=5de9c53e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de9c53e",
  null
  
)

export default component.exports